import { FilterKey } from '@retail/products/utils';

export const centralAssortmentsFilters = [
  'searchQuery',
  'inAssortment',
  'addedBy',
  'subAssortmentIds',
  'validFrom',
  'validTo',
  'includeExpiredSubAssortments',
  'productGroupNumbers',
  'supplierNumber',
  'isTagged',
  'fromMainSupplier',
  'itemIdentifiers',
] as const satisfies Array<FilterKey>;
export type CentralAssortmentsFilters = (typeof centralAssortmentsFilters)[number];

export const itemPricesFilters = [
  'productGroupNumbers',
  'discountGroupCodes',
  'searchQuery',
  'purchasePrice',
  'inAssortment',
  'forApproval',
] as const satisfies Array<FilterKey>;
export type ItemPricesFilters = (typeof itemPricesFilters)[number];

export const baseAssortmentFilters = [
  'searchQuery',
  'assortmentView',
  'purchasePrice',
  'subAssortmentIds',
  'activeItems',
  'forApproval',
  'inStock',
  'supplierNumber',
  'productGroupNumbers',
  'discountGroupCodes',
  'fromMainSupplier',
  'itemIdentifiers',
] as const satisfies Array<FilterKey>;
export type BaseAssortmentFilters = (typeof baseAssortmentFilters)[number];

export const priceControlFilters = [
  'isUnhandled',
  'searchQuery',
  'productGroupNumber',
  'discountGroupCode',
  'changeTrigger',
  'validFrom',
  'purchasePriceChangeRange',
  'salesPriceChangeRange',
  'covergeDegreeChangeRange',
] as const satisfies Array<FilterKey>;
export type PriceControlFilterOptions = (typeof priceControlFilters)[number];
